import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabaseClient";

export interface PublicAppSettings {
  WHATSAPP_NUMBER?: string;
  WHATSAPP_MESSAGE?: string;
  PRO_PLAN_PRICE?: string;
  FREE_SIMULATION_LIMIT?: string;
}

let cache: PublicAppSettings | null = null;
let cacheAt = 0;
const TTL = 60_000;
let inflight: Promise<PublicAppSettings> | null = null;

async function fetchSettings(): Promise<PublicAppSettings> {
  if (cache && Date.now() - cacheAt < TTL) return cache;
  if (inflight) return inflight;
  inflight = (async () => {
    const { data, error } = await supabase.functions.invoke("get-public-settings", {
      body: {},
    });
    if (error) throw error;
    cache = (data as PublicAppSettings) || {};
    cacheAt = Date.now();
    inflight = null;
    return cache;
  })();
  return inflight;
}

export function invalidateAppSettings() {
  cache = null;
  cacheAt = 0;
}

export function useAppSettings() {
  const [settings, setSettings] = useState<PublicAppSettings | null>(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let mounted = true;
    fetchSettings()
      .then((s) => mounted && setSettings(s))
      .catch((e) => console.error("useAppSettings:", e))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return { settings, loading };
}

export function buildWhatsAppUrl(number?: string, message?: string): string | null {
  if (!number) return null;
  const cleanNumber = number.replace(/\D/g, "");
  if (!cleanNumber) return null;
  const text = encodeURIComponent(message || "Olá!");
  return `https://wa.me/${cleanNumber}?text=${text}`;
}